import { CategoryId } from '@/config/constants';

export const COMBINED_SPORTS_ID = 'sports_and_athletics';
export const COMBINED_ORGANIZATIONS_ID = 'student_youth_organizations';
export const COMBINED_VOLUNTEER_ID = 'volunteer_and_fundraising_and_local_service';

export const COMBINED_SPORTS_CATEGORIES = [CategoryId.Athletics, CategoryId.Sports];

export const COMBINED_ORGANIZATIONS_CATEGORIES = [
  CategoryId.StudentOrganizations,
  CategoryId.YouthOrganizations,
];

export const COMBINED_VOLUNTEER_CATEGORIES = [
  CategoryId.VolunteerAndFundraising,
  CategoryId.VolunteerAndLocalService,
];

export const COMBINED_CATEGORIES_CONFIG = {
  [COMBINED_VOLUNTEER_ID]: {
    categories: COMBINED_VOLUNTEER_CATEGORIES,
    label: 'Volunteer, Fundraising & Local Service',
  },
  [COMBINED_SPORTS_ID]: {
    categories: COMBINED_SPORTS_CATEGORIES,
    label: 'Sports & Athletics',
  },
  [COMBINED_ORGANIZATIONS_ID]: {
    categories: COMBINED_ORGANIZATIONS_CATEGORIES,
    label: 'Student/Youth Organizations',
  },
} as const;

export const JAR_CATEGORIES_ORDER = [
  CategoryId.Academics,
  COMBINED_SPORTS_ID,
  CategoryId.ArtsAndCulture,
  CategoryId.CollegeAndCareer,
  CategoryId.SchedulesAndInformation,
  CategoryId.RecreationAndDiscovery,
  CategoryId.HealthAndSafety,
  COMBINED_VOLUNTEER_ID,
  COMBINED_ORGANIZATIONS_ID,
  CategoryId.FamilySupport,
];

export const getAllCombinedCategoryIds = () => Object.keys(COMBINED_CATEGORIES_CONFIG);

export const isCombinedCategory = (categoryId: string): boolean => {
  return getAllCombinedCategoryIds().includes(categoryId);
};

export const getCombinedCategoryByIndividual = (
  individualCategoryId: CategoryId
): string | null => {
  const match = Object.entries(COMBINED_CATEGORIES_CONFIG).find(([, config]) =>
    config.categories.includes(individualCategoryId)
  );
  return match ? match[0] : null;
};
